<template src="./component.html"></template>

<script>
export default {
  name: "Client"
}
</script>

<style src="./component.scss" scoped lang="scss"/>
